export const shellTranslations = {
    en: {
        en: 'English',
        ru: 'Ð ÑÑÑÐºÐ¸Ð¹',
        HOME_TITLE: 'Home',
        APPBAR_SEND_SIGNAL: 'Send signal',
        APPBAR_USERSETTINGS: 'User settings',
        APPBAR_HELP: 'Help',
        APPBAR_SIGNOUT: 'Sign Out',
        RIGHTNAV_NOTIFICATIONS: 'Notifications',
        SIDEBAR_SIGNOUT: 'Sign Out',
        SIDEBAR_SIGNOUT_TOOLTIP: 'Sign Out',
        SIDEBAR_HOME: 'Home',
        SIDEBAR_HOME_TOOLTIP: 'Home'
    },
    ru: {
        en: 'English',
        ru: 'Ð ÑÑÑÐºÐ¸Ð¹',
        HOME_TITLE: 'ÐÐ»Ð°Ð²Ð½Ð°Ñ',
        APPBAR_SEND_SIGNAL: 'ÐÐ¾ÑÐ»Ð°ÑÑ ÑÐ¸Ð³Ð½Ð°Ð»',
        APPBAR_USERSETTINGS: 'ÐÐ°ÑÑÑÐ¾Ð¹ÐºÐ¸ Ð¿Ð¾Ð»ÑÐ·Ð¾Ð²Ð°ÑÐµÐ»Ñ',
        APPBAR_HELP: 'ÐÐ¾Ð¼Ð¾ÑÑ',
        APPBAR_SIGNOUT: 'ÐÑÐ¹ÑÐ¸',
        RIGHTNAV_NOTIFICATIONS: 'ÐÐ¿Ð¾Ð²ÐµÑÐµÐ½Ð¸Ñ',
        SIDEBAR_SIGNOUT: 'ÐÑÐ¹ÑÐ¸',
        SIDEBAR_SIGNOUT_TOOLTIP: 'ÐÑÐ¹ÑÐ¸',
        SIDEBAR_HOME: 'ÐÐ»Ð°Ð²Ð½Ð°Ñ',
        SIDEBAR_HOME_TOOLTIP: 'ÐÐ»Ð°Ð²Ð½Ð°Ñ'
    }
};
